import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import de_DE from './locales/de_DE.json';
import en_GB from './locales/en_GB.json';
import en_IN from './locales/en_IN.json';
import en_US from './locales/en_US.json';
import es_ES from './locales/es_ES.json';
import es_MX from './locales/es_MX.json';
import fr_FR from './locales/fr_FR.json';
import ja_JP from './locales/ja_JP.json';
import pt_BR from './locales/pt_BR.json';
import pt_PT from './locales/pt_PT.json';
import ru_RU from './locales/ru_RU.json';
import sl_SL from './locales/sl_SL.json';
import tr_TR from './locales/tr_TR.json';

const languageId = typeof Liferay !== 'undefined'
    ? Liferay.ThemeDisplay.getLanguageId() : 'en_GB';

i18n.use(initReactI18next)
.init({
  resources: {
    de_DE: {
      translation: de_DE
    },
    en_GB: {
      translation: en_GB
    },
    en_IN: {
      translation: en_IN
    },
    en_US: {
      translation: en_US
    },
    es_ES: {
      translation: es_ES
    },
    es_MX: {
      translation: es_MX
    },
    fr_FR: {
      translation: fr_FR
    },
    ja_JP: {
      translation: ja_JP
    },
    pt_BR: {
      translation: pt_BR
    },
    pt_PT: {
      translation: pt_PT
    },
    ru_RU: {
      translation: ru_RU
    },
    sl_SL: {
      translation: sl_SL
    },
    tr_TR: {
      translation: tr_TR
    },
  },
  lng: languageId,
  fallbackLng: 'en_GB',
  interpolation: {
    escapeValue: false
  }
});

export default i18n;